module.exports = __webpack_public_path__ + "static/media/vanessa_ta.86d046eb.png";